import PropTypes from "prop-types";
import { useEffect } from "react";

import { jjLogger } from "utils/logUtils";
import { Content, Terms } from "pages/Search/components/styles";
import { useModuleMenu, useLoading } from "hooks";
import MenuItemPresenter from "presenters/MenuItemPresenter";

import Term from "./components/Term";
import SearchTermsSkeleton from "./components/SearchTermsSkeleton";

const SearchTerms = ({ onSearchTermClick }) => {
  const { loadModuleMenu, moduleMenu } = useModuleMenu();
  const { func: loadModuleMenuWithLoader, isFinished: isFinishedModuleMenu } = useLoading(loadModuleMenu);

  useEffect(() => {
    loadModuleMenuWithLoader("search-pills").catch((error) => {
      jjLogger.logError(`SearchTerms.jsx - loadModuleMenuWithLoader() - Error: Could not load module menu: ${error}`);
    });
  }, []);

  if (!isFinishedModuleMenu || !moduleMenu) return <SearchTermsSkeleton />;

  return (
    <Content>
      <Terms>
        {moduleMenu?.menuItems?.map((menuItem, index) => (
          <Term
            key={`${MenuItemPresenter.name(menuItem)}-${index}`}
            menuItem={menuItem}
            onSearchTermClick={onSearchTermClick}
          />
        ))}
      </Terms>
    </Content>
  );
};

SearchTerms.propTypes = {
  onSearchTermClick: PropTypes.func.isRequired,
};

export default SearchTerms;
